/**
* @file 运营中心-乘客订单
* */
<template>
  <div id="order">

    <el-radio-group v-model="tabAction" class="order-status-filter">
      <el-radio-button v-for="item in $const.ORDERSTATUS" :key="item.value" :label="item.value">
        {{ item.label }}
      </el-radio-button>
      <el-radio-button label="all">全部</el-radio-button>
    </el-radio-group>

    <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
                  :export-required-fields="[{ prop: 'startTime', text: '请选择下单开始时间-下单结束时间' }, { prop: 'endTime', text: '请选择下单开始时间-下单结束时间' }]"
                  hasChildren="passengerNum" loadChildrenId="id" :loadChildren="loadChildren" excel-type="CustomerOrder"
                  labelWidth="135" style="height: 95%" @listBack="listBack">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text"
                       v-if="row.status === 1 || (row.status === 5 && !['tc_order'].includes(row.channelAlias)) || (row.status === 10 && !['tc_order'].includes(row.channelAlias))"
                       @click="cancelClick(row)">退票
            </el-button>

            <el-button type="text" v-if="row.status === 10" @click="reassignmentClick(row)">改派
            </el-button>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
            row.created | filterTime
          }}
        </template>
        <template v-else-if="item.prop === 'finishTime'">{{
            row.finishTime | filterTime
          }}
        </template>
        <template v-else-if="item.prop == 'cardType'">
          <span v-if="row.idCard">{{ row.cardType | fliterCardType }}</span>
          <span v-else>-</span>
        </template>
        <!-- <template v-else-if="item.prop === 'idCard'">
          <span >{{ row.idCard | filterMaskIdCard }}</span>
        </template>
        <template v-else-if="item.prop === 'customerPhone'">
          <span >{{ row.customerPhone | filterMaskPhone }}</span>
        </template> -->
        <template v-else-if="item.prop === 'orderNo'">
          <el-tag v-if="row.isTicketChanging === 1"
                  style="margin-right: 8px;color: #ff9900;border-color: #ff9900;background: white;">改签
          </el-tag>
          <span class="link" @click="orderView = row; detailsVisible = true;">{{ row.orderNo }}</span>
        </template>
        <template v-else-if="item.prop === 'mchOrderNo'">
          <span v-if="row.mchOrderNo" class="link" @click="orderView = row; detailsVisible = true;">{{ row.mchOrderNo }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'passengerNum'">
          {{ row.passengerNum }}
          <el-tag v-if="row.passengerNum > 1 && !row.hide && row.ticketRestrictions == 2" effect="plain" type="success"
                  style="margin-left: 8px;border: 1px solid #008080;color: #008080;cursor: pointer;"
                  @click="handleConnectionSearch(row, true)">查看
          </el-tag>
          <el-tag v-if="row.passengerNum > 1 && row.hide" type="info" style="margin-left: 8px; cursor: pointer"
                  @click="handleConnectionSearch(row, false)">收起
          </el-tag>
        </template>
        <template v-else-if="item.prop === 'retreatFee'">
          <template v-if="row.status === 60 || row.isTicketChanging === 1">
            <div v-if="row.status === 60">
              <span class="util-money">￥{{ row.retreatFee || 0 }}</span>
              <span v-if="row.refundType == 2"> (平台操作)</span>
              <span v-else> {{
                  row.refundProportion ? "(" + row.refundProportion + "%退票费率" + ")" : "(无退票费)"
                }}</span>

            </div>
            <div v-if="row.isTicketChanging === 1">
              <span class="util-money">￥{{ row.ticketChangingFee || 0 }}</span>
              <span> {{
                  row.ticketChangingProportion ? "(" + row.ticketChangingProportion + "%改签费率" + ")" : "(无改签费)"
                }}</span>
            </div>
          </template>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'status'">
          {{ row.status | filterOrderStatus }}
        </template>
        <template v-else-if="item.prop === 'startStationName'">
          <div style="display: flex; align-items: center">
            <el-tag v-if="row.schedulingType" effect="plain"
                    :type="row.schedulingType === 1 ? 'success' : row.schedulingType === 3 ? 'danger' : ''"
                    style="margin-right: 8px">{{ row.schedulingType | filterConst("SCHELINGTYPE", "sort") }}
            </el-tag>
            <div style="font-weight: 600">{{ row.startStationName }} - {{ row.endStationName }}</div>
          </div>
        </template>
        <template v-else-if="item.prop === 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
        <template v-else-if="item.prop === 'startLineTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }} - {{ row.endLineTime }}
        </template>
        <template v-else-if="item.prop === 'channelAlias'">
          <span>
             <span v-if="row[item.prop] === '12306_order'">
              {{ getChannel365Display(row.distributorCode) }}
            </span>
            <span v-else>{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
          </span>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span style="color: #999" v-if="row.status === 5">待指派</span>
          <template v-else>
            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
            <span v-if="row.vehicleSeat" style="margin-left: 10px;">{{ row.vehicleSeat }}座</span>
            <span v-if="!row.licenseNo && !row.vehicleSeat">-</span>
          </template>
        </template>
        <template v-else-if="item.prop === 'driverName'">
          <span style="color: #999" v-if="row.status === 5">待指派</span>
          <span v-if="row.status !== 5">{{
              row.driverName ? row.driverName : "-"
            }}</span>
        </template>
        <template v-else-if="item.prop === 'driverPhone'">
          <span style="color: #999" v-if="row.status === 5">待指派</span>
          <span v-if="row.status !== 5">{{
              row.driverPhone ? row.driverPhone : "-"
            }}</span>
        </template>
        <template v-else-if="item.prop === 'realFee'">
          <template v-if="row.realFee || row.realFee === 0">
            <span class="util-money">¥{{ row.realFee }}</span>
            <span v-if="row.couponFee">(优惠券<span class="util-money-minus">-{{ row.couponFee }}</span>)</span>
            <span v-if="row.driverCollection === 1 || row.driverCollection === 2">(司机代收款)</span>
          </template>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee === 0">
            {{
              row.schedulingType === 3 || row.railType == 2
                  ? "¥" + row.lineFee + "起"
                  : "¥" + row.lineFee
            }}
          </span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'score'">
          <el-rate v-model="row.score" disabled></el-rate>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <orderCustomizeVehicle :visible.sync="reassignmentVisible" :order.sync="order"
                           @confirm="$refs.customTable.listFn()"/>
    <orderCustomizeDetails :visible.sync="detailsVisible" :order.sync="orderView"/>

    <el-dialog title="退票说明" :visible.sync="refundState" width="330px"
               @close="isCustomRule = false; refundFee = null">
      <div :class="{ 'text-disabled': isCustomRule }">
        <div class="cancel-money" v-for="(item, index) in refundRules" :key="index">
          {{ index + 1 }}.检票/接人时间{{ item.timeNum }}{{ item.timeType === 1 ? "小时" : "分钟" }}内办理退票的，按支付金额{{
            item.refundFee
          }}%收取退票费
        </div>
        <div class="cancel-money" style="padding-top: 20px">
          <div class="cancel-money-title">票面金额</div>
          <div class="util-money">￥{{ refundFeeObj.orderFee }}</div>
        </div>

        <div class="cancel-money">
          <div class="cancel-money-title">实付金额</div>
          <div>
            <span v-if="refundFeeObj.couponFee">优惠券-￥{{ refundFeeObj.couponFee }}</span>
            <span class="util-money">￥{{ refundFeeObj.realFee }}</span>

          </div>
        </div>

        <div class="cancel-money">
          <div class="cancel-money-title">退票费用</div>
          <div>
            <span v-if="refundFeeObj.refundProportion">退票费率{{ refundFeeObj.refundProportion }}%</span>
            <span class="util-money">￥{{ refundFeeObj.retreatFee }}</span>
          </div>
        </div>
        <div class="cancel-money">
          <div class="cancel-money-title">实际退款</div>
          <div class="cancel-money-money util-money">
            ￥{{ refundFeeObj.refundFee }}
          </div>
        </div>
      </div>

      <hr style="margin:20px 0">

      <div>
        <div style="display:flex;align-items:center;margin-bottom:10px">
          <el-checkbox v-model="isCustomRule"></el-checkbox>
          <p @click="isCustomRule = !isCustomRule" style="cursor: pointer;margin-left:10px">自定义退票手续费</p>
        </div>
        <el-input v-model="refundFee" placeholder="请输入要扣除的费用" :disabled="!isCustomRule"
                  @input="() => refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{4,}/g, '9999').replace(/(\d\d{0,3}\.?\d{0,2})?.*/g, '$1')"></el-input>
        <p style="margin-top:10px;font-size: 14px;color:red">注意：手续费不能大于实际支付金额，可输入0</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
        <el-button @click="refundState = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import orderCustomizeDetails from "./orderCustomizeDetails";
import orderCustomizeVehicle from "./orderCustomizeVehicle";

export default {
  name: "order",
  components: {orderCustomizeDetails, orderCustomizeVehicle},
  data() {
    return {
      tabAction: 10,
      loading: false,
      isCustomRule: false,
      refundFee: null,
      refundRules: [],
      refundFeeObj: {},
      refundState: false,
      channelAlias: '',
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          channelAlias: ''
        },
        search: [
          {type: "input", field: "orderNo", name: "订单号", value: ""},
          {type: "input", field: "mchOrderNo", name: "三方订单号", value: ""},
          {type: "input", field: "startStationName", name: "线路起点", value: ""},
          {type: "input", field: "endStationName", name: "线路终点", value: ""},
          {type: "input", field: "vehicleNo", name: "车辆编号", value: ""},
          {
            type: "select",
            field: "score",
            name: "订单评分",
            value: null,
            option: [
              {value: 1, label: "1星"},
              {value: 2, label: "2星"},
              {value: 3, label: "3星"},
              {value: 4, label: "4星"},
              {value: 5, label: "5星"},
              {value: 0, label: "未评价"},
            ],
          },
          {type: "input", field: "customerName", name: "乘客联系人", value: ""},
          {type: "input", field: "customerPhone", name: "联系电话", value: ""},
          {type: "input", field: "licenseNo", name: "车辆号牌", value: ""},
          {type: "input", field: "driverName", name: "司机姓名", value: ""},
          {type: "input", field: "driverPhone", name: "司机电话", value: ""},
          {
            type: "select", field: "createdOrFinishTimeSort", name: "数据排序", value: null,
            option: [
              {value: 1, label: "下单时间正序排序"},
              {value: 2, label: "下单时间倒序排序"},
              {value: 3, label: "完成/取消时间正序排序"},
              {value: 4, label: "完成/取消时间倒序排序"},
            ],
          },
          {type: "select", field: "schedulingType", name: "排班模式", value: null, option: this.$const.SCHELINGTYPE},
          {
            type: "select",
            field: "channelAlias",
            name: "下单渠道",
            value: null,
            option: this.$const.CHANNELALIAS
          },
          {
            type: "select",
            field: "distributorCode",
            name: "365上级分销商",
            value: null,
            option: this.$const.CHANNEL_365_SOURCES,
            showIf: {
              field: 'channelAlias',
              value: '12306_order'
            }
          },
          {
            type: "datetime",
            field: "time",
            name: "下单时间",
            value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)],
            defaultDays: 30
          },
          {
            type: "datetime",
            field: "finishTime",
            dateProp: {start: "finishStartTime", end: "finishEndTime"},
            name: "完成/取消时间",
            value: []
          },
        ],
      },
      // 表头
      columns: [
        {prop: "orderNo", label: "订单号", width: 250},
        {prop: "status", label: "订单状态", width: 80},
        {prop: "channelAlias", label: "订单来源", width: 130},
        {prop: "created", label: "下单时间", width: 130},
        {prop: "finishTime", label: "完成/取消时间", width: 130},
        {prop: "startStationName", label: "线路名称", minWidth: 500},
        {prop: "startLineTime", label: "班次", width: 140},
        {prop: "customerName", label: "乘客", width: 90},
        {prop: "cardType", label: "证件类型", width: 160},
        {prop: "idCard", label: "证件号码", width: 150},
        {prop: "customerPhone", label: "联系电话", width: 110},
        {prop: "passengerNum", label: "乘客数", width: 80},
        {prop: "seatNo", label: "座位", width: 60},
        {prop: "lineFee", label: "车票价格", width: 80},
        {prop: "realFee", label: "实付金额", width: 130},
        {prop: "retreatFee", label: "退改金额", width: 130},
        {prop: "licenseNo", label: "车辆号牌", width: 200},
        {prop: "vehicleNo", label: "车辆编号", width: 100},
        {prop: "driverName", label: "司机姓名", width: 80},
        {prop: "driverPhone", label: "司机电话", width: 105},
        {prop: "score", label: "评分", width: 140},
        {prop:'mchOrderNo',label: "三方订单号",width:200},
      ],
      // 状态
      status: null,
      schedulingType: '',
      order: {},
      orderView: {},
      reassignmentVisible: false,
      detailsVisible: false,
    };
  },
  computed: {
    ...mapGetters([
      "userInfoGetter",
    ]),
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = val != "all" ? val : null;
      console.log(555,2332);
      this.$refs.customTable.listFn();
    },
  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    } else {
      this.customOptions.params.status = 10;
      this.tabAction = 10;
    }
  },
  mounted() {
    // 延迟监听，确保search组件已初始化
    setTimeout(() => {
      const customSearch = this.$refs.customTable?.$refs?.customSearch;
      if (customSearch && customSearch.copySearch) {
        this.$watch(
          () => customSearch.copySearch.find(item => item.field === 'channelAlias')?.value,
          (newVal) => {
            this.handleChannelAliasChange(newVal, customSearch);
          },
          { immediate: true }
        );
      }
    }, 1000);
  },
  methods: {
    /**
     * 获取出行365渠道显示名称
     * 搜索得到时显示结果，否则显示"出行365"
     */
    getChannel365Display(distributorCode) {
      const item = this.$const.CHANNEL_365_SOURCES.find(v => v.value == distributorCode);
      return item ? item.label : '出行365';
    },
    listBack(val) {
      // 修复乘客数点击展开后查询再次点击无法展开
      this.$refs.customTable.toggleIndex = Math.random();
    },
    /**
     * 状态改变
     */
    schedulingTypeChange(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.schedulingType = val;
      this.$refs.customTable.listFn();
    },
    channelAliasChange() {
      this.customOptions.params.channelAlias = this.channelAlias
      this.$refs.customTable.listFn()
    },
    handleChannelAliasChange(channelAlias, customSearch) {
      if (!customSearch) return;
      const copySearch = customSearch.copySearch;
      const distributorIndex = copySearch.findIndex(item => item.field === 'distributorCode');
      const channelAliasIndex = copySearch.findIndex(item => item.field === 'channelAlias');
      if (channelAlias === '12306_order') {
        if (distributorIndex === -1 && channelAliasIndex !== -1) {
          copySearch.splice(channelAliasIndex + 1, 0, {
            type: "select",
            field: "distributorCode",
            name: "365上级分销商",
            value: null,
            option: this.$const.CHANNEL_365_SOURCES
          });
        }
      } else {
        if (distributorIndex !== -1) {
          copySearch.splice(distributorIndex, 1);
          this.customOptions.params.distributorCode = null;
        }
      }
    },
    // 按钮触发展开行
    async handleConnectionSearch(row, bl) {
      console.log('bl::: ', bl);
      if (bl) {
        let url = `/api/v1/manage/order/orderCustomer/customer/${row.id}`;
        let data = await this.$axios.get(url);
        if (data && data.code === 1) {
          if (data.data.length == 0) {
            return this.$message.warning("没有找到相关乘客");
          }
          const filteredData = data.data.filter(item => item.isDefault !== 1);
          row.children = filteredData;
          row.hide = true;
          this.$refs.customTable.$refs.tableInner.toggleRowExpansion(row, bl);
        }
      } else {
        row.hide = false;
        this.$refs.customTable.$refs.tableInner.toggleRowExpansion(row, bl);
      }
    },
    // 查询订单乘客列表
    async loadChildren(tree, treeNode, resolve) {
      let url = "/api/v1/manage/order/orderCustomer/customer/" + tree.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.$message.warning("没有找到相关乘客");
        } else {
          for (const item of data.data) {
            if (item.isDefault == 1) {
              continue;
            } else {
              item.id = 9999999;
            }
          }
          resolve(data.data);
        }
      } else {
        this.$message.error("查询错误");
        resolve([
          {
            msg: "接口错误",
          },
        ]);
      }
    },
    async getRefundRules() {
      let url = "/api/v1/manage/order/refund/" + +this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.refundRules = data.data || [];
      }
    },
    async getRefundFeeObj() {
      let url = "/api/v1/manage/order/getRefundFee/" + +this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.refundFeeObj = data.data || [];
        return true;
      } else {
        return false;
      }
    },
    reassignmentClick(row) {
      this.order = row;
      this.reassignmentVisible = true;
    },
    /**
     * 取消订单
     */
    async cancelClick(row) {
      this.order = row;
      let res = await this.getRefundFeeObj();
      if (!res) {
        return;
      }
      await this.getRefundRules();
      if (this.refundRules && this.refundRules.length > 0) {
        this.refundState = true;
      } else {
        this.$confirm("确认要取消本订单吗?", "退票提示").then(async () => {
          this.postCancel();
        });
      }
    },
    async cancelConfirm() {
      if (this.isCustomRule) {
        if (this.refundFee.trim() === '') {
          this.$message.warning({
            message: '请输入要扣除的费用'
          });
          return;
        }
      }
      this.loading = true;
      await this.postCancel();
      this.loading = false;
    },
    async postCancel() {
      let params = {};
      if (this.isCustomRule) {
        params.refundFee = this.refundFee;
      }
      let url = "/api/v1/manage/order/cancel/" + this.order.id;
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("操作成功");
        this.$refs.customTable.listFn();
        this.refundState = false;
      }
    },
  },
};
</script>

<style lang="less">
#order {
  .order-status-filter {
    margin-bottom: 16px;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 4px;
    display: inline-flex;

    .el-radio-button {
      margin: 0 2px;

      .el-radio-button__inner {
        background: transparent;
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
      }

      &.is-active .el-radio-button__inner {
        background: #2B77FF;
        color: #fff;
        box-shadow: none;
      }
    }
  }

  .el-dialog {
    .customTable-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .dialog-line-list {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-tabs {
      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__nav-wrap::after {
        background-color: transparent;
      }
    }

    .el-dialog__body {
      padding-top: 10px;
    }

    .dialog-top {
      display: flex;
      line-height: 28px;
      font-size: 14px;
      margin-bottom: 12px;

      .dialog-top-item + .dialog-top-item {
        margin-left: 16px;
      }

      .line-name {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .dialog-table {
      min-height: 200px;
    }

    .table-operation-choose {
      cursor: pointer;
      color: @color-primary;
    }
  }

  .cancel-money {
    display: flex;
    justify-content: space-between;

    .cancel-money-title {
      font-weight: 600;
    }

    .cancel-money-money {
      font-weight: 600;
    }

    .util-money {
      padding-left: 8px;
    }
  }

  .cancel-money + .cancel-money {
    padding-top: 14px;
  }

  .el-table__expand-icon {
    display: none;
  }
}
</style>
